import React from 'react';

import { PrimaryFilters as PrimaryFiltersProvider } from 'components/Filters';

import {
  FILTER_ADDED,
  FILTER_PERIOD,
  FILTER_ACTIONS_TYPE,
} from 'scenes/SpendAdjustments/constants';

import SpendAdjustmentsFilters from './filters';

export const PRIMARY_FILTERS = [
  FILTER_ADDED,
  FILTER_PERIOD,
  FILTER_ACTIONS_TYPE,
];

const PrimaryFilters = () => (
  <PrimaryFiltersProvider primary={PRIMARY_FILTERS}>
    <SpendAdjustmentsFilters.Added />
    <SpendAdjustmentsFilters.Period />
    <SpendAdjustmentsFilters.ActionsType withClear={true} />
    <SpendAdjustmentsFilters.Types withClear={true} />
    <SpendAdjustmentsFilters.Affiliates
      dropdownWidth={'440px'}
      withClear={true}
    />
    <SpendAdjustmentsFilters.Applications withClear={true} />
    <SpendAdjustmentsFilters.Networks withClear={true} />
    <SpendAdjustmentsFilters.Clusters withClear={true} />
    <SpendAdjustmentsFilters.Platforms withClear={true} />
    <SpendAdjustmentsFilters.Statuses withClear={true} />
    <SpendAdjustmentsFilters.Reasons withClear={true} />
    <SpendAdjustmentsFilters.CreatedBy withClear={true} />
  </PrimaryFiltersProvider>
);

export default PrimaryFilters;
